import { AxiosError } from 'axios';

type ApiErrorBody = { error?: { status?: string } };
type ApiError = AxiosError<ApiErrorBody>;

const isApiError = (error: unknown): error is ApiError =>
  typeof error === 'object' && error !== null && 'response' in error;

export const apiErrorStatus = (error: unknown): string | undefined =>
  isApiError(error) ? error.response?.data?.error?.status : undefined;

export const apiHttpStatus = (error: unknown): number | undefined =>
  isApiError(error) ? error.response?.status : undefined;
